import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { currencyValueFormatter } from "@cinch-labs/shared-util";
import styles from "./price.module.css";
export var Price = function(param) {
    var price = param.price, discountInPence = param.discountInPence;
    var formattedPrice = currencyValueFormatter(price);
    var formattedPreDiscountPrice = currencyValueFormatter(price + discountInPence / 100);
    var isDiscounted = !!discountInPence;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            isDiscounted && /*#__PURE__*/ _jsxs("span", {
                className: styles.discounted,
                children: [
                    "Was ",
                    /*#__PURE__*/ _jsx("s", {
                        children: formattedPreDiscountPrice
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.price,
                children: formattedPrice
            })
        ]
    });
};
